(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-product-grid"]) return;
  try {
    
(() => {
  const source = 'downloadable-collection-toggle';
  const selector = '.collection-audio-product__cart-toggle';
  const lineKeysByVariant = new Map();

  function setButtonState(button, lineKey) {
    const added = Boolean(lineKey);
    button.dataset.lineKey = lineKey || '';
    button.classList.toggle('is-added', added);
    button.classList.remove('is-pending');
    button.disabled = false;
    const badge = button.querySelector('.collection-audio-product__cart-badge');
    if (badge) badge.textContent = added ? '✓' : '';
    button.setAttribute('aria-pressed', added ? 'true' : 'false');
    const label = added
      ? button.dataset.removeLabel
      : button.dataset.addLabel + ' ' + button.dataset.productTitle;
    button.setAttribute('aria-label', label);
    button.title = label;
  }

  function syncButtons() {
    document.querySelectorAll(selector).forEach((button) => {
      if (button.dataset.pending === 'true' || button.classList.contains('is-error')) return;
      setButtonState(button, lineKeysByVariant.get(String(button.dataset.variantId)));
    });
  }

  function syncCartState(cart) {
    if (!cart || !Array.isArray(cart.items)) return;
    lineKeysByVariant.clear();
    cart.items.forEach((item) => {
      const variantId = String(item.variant_id);
      if (!lineKeysByVariant.has(variantId)) {
        lineKeysByVariant.set(variantId, item.key);
      }
    });
    syncButtons();
  }

  async function fetchCart() {
    const response = await fetch(window.routes.cart_url + '.js', {
      headers: { Accept: 'application/json' },
    });
    if (!response.ok) throw new Error(window.cartStrings?.error || 'Could not read the cart.');
    return response.json();
  }

  async function postCart(route, payload) {
    const url = route.endsWith('.js') ? route : route + '.js';
    const response = await fetch(url, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(payload),
    });
    const data = await response.json();
    if (!response.ok) {
      throw new Error(data.description || data.message || window.cartStrings?.error || 'Could not update the cart.');
    }
    return data;
  }

  function updateCartBubble(sectionHtml) {
    if (!sectionHtml) return;
    const parsed = new DOMParser().parseFromString(sectionHtml, 'text/html');
    const sourceBubble = parsed.querySelector('#cart-icon-bubble');
    const targetBubble = document.querySelector('#cart-icon-bubble');
    if (!sourceBubble || !targetBubble) return;

    Array.from(sourceBubble.attributes).forEach((attribute) => {
      if (attribute.name !== 'id') targetBubble.setAttribute(attribute.name, attribute.value);
    });
    targetBubble.innerHTML = sourceBubble.innerHTML;
  }

  async function fetchCartBubbleSection() {
    const url = new URL(window.location.pathname, window.location.origin);
    url.searchParams.set('sections', 'cart-icon-bubble');
    const response = await fetch(url, { headers: { Accept: 'application/json' } });
    if (!response.ok) return null;
    const sections = await response.json();
    return sections['header'];
  }

  async function refreshCartUI(cart, sections) {
    syncCartState(cart);
    let bubble = sections && sections['header'];
    if (!bubble) {
      try {
        bubble = await fetchCartBubbleSection();
      } catch (error) {
        console.error('[Downloadable cart] Could not refresh the cart bubble.', error);
      }
    }
    updateCartBubble(bubble);

    if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      try {
        await publish(PUB_SUB_EVENTS.cartUpdate, {
          source,
          cartData: cart,
        });
      } catch (error) {
        console.error('[Downloadable cart] Could not refresh the cart drawer.', error);
      }
    }
  }

  function reportError(button, error) {
    const status = button.closest('.collection-audio-product')?.querySelector('.collection-audio-product__status');
    const message = error.message || window.cartStrings?.error || 'Could not update the cart.';
    if (status) status.textContent = message;
    const badge = button.querySelector('.collection-audio-product__cart-badge');
    if (badge) badge.textContent = '!';
    button.classList.add('is-error');
    button.title = message;
    window.setTimeout(() => {
      if (status) status.textContent = '';
      button.classList.remove('is-error');
      setButtonState(button, lineKeysByVariant.get(String(button.dataset.variantId)));
    }, 5000);
  }

  document.addEventListener('click', async (event) => {
    const button = event.target.closest(selector);
    if (!button || button.disabled) return;
    event.preventDefault();

    const variantId = String(button.dataset.variantId);
    const lineKey = lineKeysByVariant.get(variantId);
    button.dataset.pending = 'true';
    button.disabled = true;
    button.classList.add('is-pending');
    const badge = button.querySelector('.collection-audio-product__cart-badge');
    if (badge) badge.textContent = '';

    try {
      if (lineKey) {
        const cart = await postCart(window.routes.cart_change_url, {
          id: lineKey,
          quantity: 0,
          sections: 'header',
          sections_url: window.location.pathname,
        });
        button.dataset.pending = 'false';
        await refreshCartUI(cart, cart.sections);
      } else {
        const result = await postCart(window.routes.cart_add_url, {
          items: [{ id: Number(variantId), quantity: 1 }],
          sections: 'header',
          sections_url: window.location.pathname,
        });
        let cart;
        try {
          cart = await fetchCart();
        } catch (error) {
          const addedLine = Array.isArray(result.items)
            ? result.items.find((item) => String(item.variant_id) === variantId)
            : result;
          if (addedLine?.key) lineKeysByVariant.set(variantId, String(addedLine.key));
        }
        button.dataset.pending = 'false';
        if (cart) {
          await refreshCartUI(cart, result.sections);
        } else {
          syncButtons();
          updateCartBubble(result.sections && result.sections['header']);
        }
      }
    } catch (error) {
      button.dataset.pending = 'false';
      setButtonState(button, lineKeysByVariant.get(variantId));
      reportError(button, error);
    }
  });

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      if (event?.source === source) return;
      if (event?.cartData?.items) syncCartState(event.cartData);
      else fetchCart().then(syncCartState).catch(() => {});
    });
  }

  const gridContainer = document.getElementById('ProductGridContainer');
  if (gridContainer) {
    let syncQueued = false;
    new MutationObserver(() => {
      if (syncQueued) return;
      syncQueued = true;
      requestAnimationFrame(() => {
        syncQueued = false;
        syncButtons();
      });
    }).observe(gridContainer, { childList: true, subtree: true });
  }

  fetchCart().then(syncCartState).catch((error) => {
    console.error('[Downloadable cart] Could not initialize cart state.', error);
  });
})();

  } catch(e) { console.error(e); }
})();
})();
